const state = {
    queryResultFields: [
        {
            key: "date",
            label: "日期",
            sortable: false,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "site",
            label: "廠區",
            sortable: false,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "process",
            label: "製程",
            sortable: false,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "group",
            label: "組別",
            sortable: false,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "device",
            label: "機台",
            sortable: false,
            class: "font-family-dfyuanstd-w5"
        }
    ],
    queryResultItem: [],
}
const getters = {
    get_queryResultFields: state => {
        return state.queryResultFields
    },
    get_queryResultItem: state => {
        return state.queryResultItem
    },
}
const actions = {
    set_queryResultFields(context, array) {
        context.commit('SET_QUERYRESULTFIELDS', array);
    },
    set_queryResultItem(context, array) {
        context.commit('SET_QUERYRESULTITEM', array);
    },
    clear_queryResultItem(context) {
        context.commit('CLEAR_QUERYRESULTITEM');
    },
}
const mutations = {
    SET_QUERYRESULTFIELDS(state, array) {
        state.queryResultFields = array;
    },
    SET_QUERYRESULTITEM(state, array) {
        state.queryResultItem = array;
    },
    CLEAR_QUERYRESULTITEM(state) {
        state.queryResultItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/queryResult.js